(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__main"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-countdown-timer-bar"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class CountdownTimerBarSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.countdown = this.query('[data-pxu-countdown-timer-bar-countdown]');
    this.days = this.query('[data-pxu-countdown-timer-bar-countdown-day]');
    this.hours = this.query('[data-pxu-countdown-timer-bar-countdown-hrs]');
    this.minutes = this.query('[data-pxu-countdown-timer-bar-countdown-min]');
    this.seconds = this.query('[data-pxu-countdown-timer-bar-countdown-sec]');
    this.dateTime = this.data.countdownDatetime;

    this.targetDate = this.dateTime ? Date.parse(this.dateTime) : null;
    this.daysInMs = 1000 * 60 * 60 * 24;
    this.hoursInMs = this.daysInMs / 24;
    this.minutesInMs = this.hoursInMs / 60;
    this.secondsInMs = this.minutesInMs / 60;
    this.timeoutId = null;
    this.isLoading = true;

    this.onMount();
  }

  onMount() {
    this.startTimer();
  }

  onUnmount() {
    this.stopTimer();
  }
  updateLoadingState() {
    // Remove the loading class once the countdown is ready.
    this.countdown.classList.remove('pxu-countdown-timer__countdown--loading');
  }

  startTimer() {
    const interval = 1000;
    let expectedTime = Date.now() + interval;

    // If the target date has already passed, handle countdown completion.
    if (this.targetDate <= Date.now()) {
      this.updateLoadingState();
      this.handleCountDownComplete();
      return;
    }

    const countDown = () => {
      const currentDate = Date.now();
      const timeDiff = this.targetDate - currentDate;

      // If time difference is zero or less, stop the timer and handle countdown completion.
      if (timeDiff <= 0) {
        this.stopTimer();
        this.handleCountDownComplete();
        return;
      }

      // Convert the time difference, calculate the drift, and adjust the expected time.
      const remainingTime = this.convertTime(timeDiff);
      const drift = currentDate - expectedTime;
      expectedTime += interval;

      // Update the loading state and update the DOM with the remaining time.
      if (this.isLoading) this.updateLoadingState();
      this.updateDom(remainingTime);

      this.timeoutId = setTimeout(countDown, Math.max(0, interval - drift));
    };

    this.timeoutId = setTimeout(countDown, interval);
  }

  stopTimer() {
    // Stop the countdown and clear the timeout.
    clearTimeout(this.timeoutId);
  }

  convertTime(timeInMs) {
    // Convert the time difference into days, hours, minutes, and seconds.
    const days = parseInt(timeInMs / this.daysInMs, 10);
    timeInMs -= days * this.daysInMs;

    const hours = parseInt(timeInMs / this.hoursInMs, 10);
    timeInMs -= hours * this.hoursInMs;

    const minutes = parseInt(timeInMs / this.minutesInMs, 10);
    timeInMs -= minutes * this.minutesInMs;

    const seconds = parseInt(timeInMs / this.secondsInMs, 10);

    // Return an object with the calculated time.
    return { days, hours, minutes, seconds };
  }

  updateDom(dateObj) {
    // Update DOM elements with the remaining time.
    const { days, hours, minutes, seconds } = dateObj;
    this.days.textContent = days;
    this.hours.textContent = hours;
    this.minutes.textContent = minutes;
    this.seconds.textContent = seconds;
  }

  handleCountDownComplete() {
    // Update the DOM once the countdown is complete.
    this.updateDom({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    // Add the complete class once the countdown is complete.
    this.countdown.classList.add('pxu-countdown-timer-bar__countdown--complete');
  }
}

document.querySelectorAll('[data-pxu-countdown-timer-bar]').forEach(($section) => {
  Section.init($section, CountdownTimerBarSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.CountdownTimerBarSection = CountdownTimerBarSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class ScrollingTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.contentItems = this.$root.querySelectorAll('[data-scrolling-text-content]');

    this.onMount();
  }

  // Section lifecycle

  onMount() {
    this._initScroll();
  }

  _initScroll() {
    this.contentItems.forEach(el => {
      const textItems = el.querySelectorAll('[data-scrolling-text-content-item]');
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items.
      const totalItemWidth = [...textItems].reduce((total, item) => total + item.offsetWidth, 0);

      // Calculate the number of marquee items needed to fill the container.
      const numItems = Math.ceil(width / totalItemWidth);

      // Clone and append marquee items.
      for (let i = 0; i < numItems; i++) {
        textItems.forEach(item => {
          const clone = item.cloneNode(true);
          el.appendChild(clone);
        });
      }
    });

    this._observeAnimations();
  }

  _observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(debounce(([entry]) => {
      const { isIntersecting } = entry;
      this.$root.classList.toggle('pxu-scrolling-text--is-animated', isIntersecting);
    }, 100));

    this.observer.observe(this.$root);
  }

  onUnmount(){
    this.observer.unobserve(this.$root);
  }
}

document.querySelectorAll('[data-pxu-scrolling-text]').forEach(($section) => {
  Section.init($section, ScrollingTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ScrollingTextSection = ScrollingTextSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-with-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoWithTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.$shopifyVideo = this.query('.pxu-video-with-text__video');
    this.id = $root.id;
    this.data = this.loadData();
    this.observer = null;

    this.onMount();
  }

  onMount() {
    if (this.$shopifyVideo) this.initIntersectionObserver();
  }

  onUnmount() {
    if (this.$shopifyVideo) this.observer.unobserve(this.$root);
  }


  initIntersectionObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.initVideo();
          observer.unobserve(this.$root);
        }
      });
    }, { threshold: 0 });
    this.observer.observe(this.$root);
  }

  initVideo() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      this.$shopifyVideo.setAttribute('controls', '');
    } else if (this.data.enableVideoAutoplay) {
      this.$shopifyVideo.play();
    }
  }
}

document.querySelectorAll('[data-pxu-video-with-text]').forEach(($section) => {
  Section.init($section, VideoWithTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.VideoWithTextSection = VideoWithTextSection;
}

  } catch(e) { console.error(e); }
})();
})();
